
export const packages = [
  "@stssocialst-stp/fe-core",
  "@stssocialst-stp/fe-individual",
  "@stssocialst-stp/fe-social_protection",
  "@stssocialst-stp/fe-opensearch_reports",
  "@stssocialst-stp/fe-invoice",
  "@stssocialst-stp/fe-grievance_social_protection",
  "@stssocialst-stp/fe-home",
  "@stssocialst-stp/fe-location",
  "@stssocialst-stp/fe-medical",
  "@stssocialst-stp/fe-profile",
  "@stssocialst-stp/fe-language_fr",
  "@stssocialst-stp/fe-calculation",
  "@stssocialst-stp/fe-policyholder",
  "@stssocialst-stp/fe-contribution_plan",
  "@stssocialst-stp/fe-payment_cycle",
  "@stssocialst-stp/fe-contract",
  "@stssocialst-stp/fe-tasks_management",
  "@stssocialst-stp/fe-coremis_language_pack",
  "@stssocialst-stp/fe-payroll",
  "@stssocialst-stp/fe-deduplication",
  "@stssocialst-stp/fe-admin",
  "@stssocialst-stp/fe-language_pt_st"
];


export function loadModules(cfg = {}) {
  const loadedModules = [];

  try {
    loadedModules.push(require("@stssocialst-stp/fe-core").CoreModule(cfg["fe-core"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-core". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-individual").IndividualModule(cfg["fe-individual"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-individual". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-social_protection").SocialProtectionModule(cfg["fe-social_protection"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-social_protection". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-opensearch_reports").OpenSearchReportsModule(cfg["fe-opensearch_reports"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-opensearch_reports". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-invoice").InvoiceModule(cfg["fe-invoice"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-invoice". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-grievance_social_protection").GrievanceSocialProtectionModule(cfg["fe-grievance_social_protection"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-grievance_social_protection". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-home").HomeModule(cfg["fe-home"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-home". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-location").LocationModule(cfg["fe-location"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-location". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-medical").MedicalModule(cfg["fe-medical"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-medical". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-profile").ProfileModule(cfg["fe-profile"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-profile". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-language_fr").LanguageFrModule(cfg["fe-language_fr"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-language_fr". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-calculation").CalculationModule(cfg["fe-calculation"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-calculation". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-policyholder").PolicyHolderModule(cfg["fe-policyholder"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-policyholder". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-contribution_plan").ContributionPlanModule(cfg["fe-contribution_plan"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-contribution_plan". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-payment_cycle").PaymentCycleModule(cfg["fe-payment_cycle"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-payment_cycle". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-contract").ContractModule(cfg["fe-contract"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-contract". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-tasks_management").TasksManagementModule(cfg["fe-tasks_management"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-tasks_management". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-coremis_language_pack").CoreMISLanguageModule(cfg["fe-coremis_language_pack"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-coremis_language_pack". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-payroll").PayrollModule(cfg["fe-payroll"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-payroll". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-deduplication").DeduplicationModule(cfg["fe-deduplication"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-deduplication". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-admin").AdminModule(cfg["fe-admin"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-admin". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@stssocialst-stp/fe-language_pt_st").LanguagePtModule(cfg["fe-language_pt_st"] || {}));
  } catch (error) {
    alert(`Failed to load module "@stssocialst-stp/fe-language_pt_st". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }


  try {
    loadedModules.push(require("./prl").PrlModule(cfg["prl" ] || {}));
  } catch (error) {
    alert(`Failed to load local module "./prl". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("./params").ParamsModule(cfg["params" ] || {}));
  } catch (error) {
    alert(`Failed to load local module "./params". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  return loadedModules;
}
